"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LegacyGOSManager = exports.GOSManager = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /** @module GOSManager **/


var _GameOverScreen = require("./GameOverScreen");

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* @class
* @classdesc GameOverScreen manager, controls flow of calls made to GameOverScreen
*
* @param {module:GameOverScreen~GameOverScreenInterface}
*/
var GOSManager = function () {
    function GOSManager(gosModule) {
        _classCallCheck(this, GOSManager);

        this.gos = gosModule;
    }

    /**
    * Resets the GameOverScreen
    */


    _createClass(GOSManager, [{
        key: "reset",
        value: function reset() {
            if (this.gos) {
                this.gos.reset();
            }
        }

        /**
        * Initialize the game over screen with the game and start response
        *
        * @param {GameModel} gameModel
        * @param {GameServiceResponse} startResponse
        */

    }, {
        key: "setup",
        value: function setup(gameModel, startResponse) {
            if (this.gos) {
                this.gos.setup(null, startResponse);
            }
        }

        /**
        * Initialize the game over screen with an error response
        *
        * @param {GameModel} gameModel
        * @param {GameServiceError} errResponse
        */

    }, {
        key: "setupGameFailed",
        value: function setupGameFailed(gameModel, errResponse) {
            if (this.gos) {
                this.gos.setup(errResponse);
            }
        }

        /**
        * Initialize a game over screen with end response and show it
        *
        * @param {GameModel} gameModel
        * @param {GameServiceResponse} endResponse
        */

    }, {
        key: "setupGameEnded",
        value: function setupGameEnded(gameModel, endResponse) {
            if (this.gos) {
                var data = endResponse.body.data || {};
                if (data.autoClaim) {
                    this.gos.setAutoClaim(true);
                }
                this.gos.setPathStatus(endResponse.body.path && endResponse.body.path.status);
                this.gos.open();
            }
        }
    }]);

    return GOSManager;
}();

/**
* @class
* @classdesc Manager for legacy game over screen module
* @deprecated
*/


var LegacyGOSManager = function () {
    function LegacyGOSManager(gosModule) {
        _classCallCheck(this, LegacyGOSManager);

        this.gos = gosModule;
    }

    _createClass(LegacyGOSManager, [{
        key: "reset",
        value: function reset() {
            // do nothing
        }
    }, {
        key: "setup",
        value: function setup(gameModel, startResponse) {
            if (!this.gos) {
                return;
            }

            var data = startResponse.body.data;
            var response = {};
            var gosData = {};
            if (data && data.iw_response) {
                response = data.iw_response.response || data.iw_response;
            }

            if (startResponse.body.status !== 'error' && response.type !== 'error') {
                gosData = (0, _utils.objectAssign)({}, {
                    error: false,
                    tokenDesc: gameModel.getGamePlayDesc(),
                    prizeType: response.data && response.data.prizeType,
                    prizeValue: response.data && response.data.prizeValue
                });
                gosData = (0, _utils.objectAssign)(gosData, response.data && response.data.gos || {});
            } else {
                gosData = (0, _utils.objectAssign)({ error: true }, response && response.data && response.data.gos || {});
            }
            this.gos.setup(gosData);
        }
    }, {
        key: "setupGameFailed",
        value: function setupGameFailed(gameModel, errResponse) {
            if (!this.gos) {
                return;
            }
            var data = errResponse && errResponse.body || {};
            var response = null;
            var gosData = {};
            if (data.iw_response) {
                response = data.iw_response.response || data.iw_response;
            }
            gosData = (0, _utils.objectAssign)({ error: true }, typeof response !== 'undefined' && response.data ? response.data.gos : null);
            this.gos.setup(gosData);
        }
    }, {
        key: "setupGameEnded",
        value: function setupGameEnded(gameModel, endResponse) {
            if (!this.gos) {
                return;
            }
            var data = endResponse.body.data || {};
            if (data.autoClaim) {
                this.gos.setAutoClaim(true);
            }
            this.gos.open();
        }
    }]);

    return LegacyGOSManager;
}();

/**
* Factory method to return an appropriate GOSManager instance given the gos module
*
* @param {module:GameOverScreen~GameOverScreenInterface|object} gosModule - if a GameOverScreenInterface instance is given, the GOSManager will be provided, otherwise it is assumed it is the legacy module
*
* @return {module:GOSManager~GOSManager|module:GOSManager~LegacyGOSManager}
*/


function factory(gosModule) {
    if (gosModule && !(gosModule instanceof _GameOverScreen.GameOverScreenInterface)) {
        return new LegacyGOSManager(gosModule);
    }
    return new GOSManager(gosModule);
}

exports.GOSManager = GOSManager;
exports.LegacyGOSManager = LegacyGOSManager;
exports.default = factory;